import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useState, useEffect } from "react";

var useFetch = function useFetch(url, options) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      response = _useState2[0],
      setResponse = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var checkResponseError = function checkResponseError(fetchResponse) {
    if (fetchResponse.ok) {
      return null;
    }

    var fetchErr = {
      code: fetchResponse.status,
      err: new Error(fetchResponse.statusText)
    };
    return fetchErr;
  };

  var fetchData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var res, fetchError, json, _fetchError;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch(url, options);

            case 3:
              res = _context.sent;
              fetchError = checkResponseError(res);

              if (!fetchError) {
                _context.next = 9;
                break;
              }

              setError(fetchError);
              setIsLoading(false);
              return _context.abrupt("return");

            case 9:
              _context.next = 11;
              return res.json();

            case 11:
              json = _context.sent;
              setError(null);
              setResponse(json);
              setIsLoading(false);
              _context.next = 22;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](0);
              _fetchError = {
                err: _context.t0
              };
              setError(_fetchError);
              setIsLoading(false);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 17]]);
    }));

    return function fetchData() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    fetchData();
  }, []);
  return [response, isLoading, error];
};

export default useFetch;